import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import { interviewAvailabilityShape } from '../../../dateUtils';
import { isMobile } from '../../../screenUtils';
import capitalize from '../../../stringUtils';
import InterviewCardOverlay from './InterviewCardOverlay';
import './Interview.scss';
var Interview = /*#__PURE__*/function (_Component) {
  function Interview(props) {
    var _this;
    _classCallCheck(this, Interview);
    _this = _callSuper(this, Interview, [props]);
    _defineProperty(_this, "updateOverlayPlacement", function () {
      var onMobile = window.innerWidth <= 768;
      _this.setState({
        overlayPlacement: onMobile ? 'top' : 'right'
      });
    });
    _this.state = {
      showCard: false,
      overlayPlacement: 'right'
    };
    _this.listItemRef = /*#__PURE__*/createRef();
    _this.overlayContainerRef = /*#__PURE__*/createRef();
    _this.editModalRef = null;
    _this.rescheduleModalRef = null;
    _this.setEditModalRef = _this.setEditModalRef.bind(_this);
    _this.setResheduleModalRef = _this.setResheduleModalRef.bind(_this);
    _this.handleOverlayClose = _this.handleOverlayClose.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.renderDateAndTime = _this.renderDateAndTime.bind(_this);
    _this.renderTypeBadge = _this.renderTypeBadge.bind(_this);
    _this.renderDurationAndGuests = _this.renderDurationAndGuests.bind(_this);
    _this.renderUpcoming = _this.renderUpcoming.bind(_this);
    _this.renderPast = _this.renderPast.bind(_this);
    _this.renderPending = _this.renderPending.bind(_this);
    _this.renderReschedule = _this.renderReschedule.bind(_this);
    _this.render = _this.render.bind(_this);
    _this.renderInterviewFuncMapping = {
      upcoming: _this.renderUpcoming,
      past: _this.renderPast,
      pending: _this.renderPending,
      reschedule: _this.renderReschedule
    };
    return _this;
  }
  _inherits(Interview, _Component);
  return _createClass(Interview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateOverlayPlacement();
      window.addEventListener('resize', this.updateOverlayPlacement);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateOverlayPlacement);
    }
  }, {
    key: "setEditModalRef",
    value: function setEditModalRef(el) {
      this.editModalRef = el;
    }
  }, {
    key: "setResheduleModalRef",
    value: function setResheduleModalRef(el) {
      this.rescheduleModalRef = el;
    }
  }, {
    key: "handleOverlayClose",
    value: function handleOverlayClose() {
      var _this$editModalRef$is, _this$editModalRef, _this$rescheduleModal, _this$rescheduleModal2;
      if (this.editModalRef && (_this$editModalRef$is = (_this$editModalRef = this.editModalRef).isModalOpen) !== null && _this$editModalRef$is !== void 0 && _this$editModalRef$is.call(_this$editModalRef) || this.rescheduleModalRef && (_this$rescheduleModal = (_this$rescheduleModal2 = this.rescheduleModalRef).isModalOpen) !== null && _this$rescheduleModal !== void 0 && _this$rescheduleModal.call(_this$rescheduleModal2)) {
        return;
      }
      this.setState({
        showCard: false
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
        consultantView = _this$props.consultantView,
        interviewType = _this$props.interviewType;
      if (!(consultantView && interviewType === 'pending')) {
        this.setState(function (prevState) {
          return {
            showCard: !prevState.showCard
          };
        });
      }
    }
  }, {
    key: "renderDateAndTime",
    value: function renderDateAndTime() {
      var interview = this.props.interview;
      if (!interview.accepted_time) return null;
      var dateStr = interview.accepted_time.date;
      var date = new Date(dateStr);
      var month = date.toLocaleString('default', {
        timeZone: 'UTC',
        month: 'short'
      });
      var day = date.getUTCDate();
      var timeAndDateStr = "".concat(dateStr, " ").concat(interview.accepted_time.start_time);
      var m = moment(timeAndDateStr);
      return /*#__PURE__*/React.createElement("div", {
        className: "date-and-time"
      }, /*#__PURE__*/React.createElement("div", {
        className: "date"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "medium-weight"
      }, day), /*#__PURE__*/React.createElement("div", {
        className: "normal-weight interview-month"
      }, month)), /*#__PURE__*/React.createElement("div", {
        className: "time ms-3"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "normal-weight"
      }, m.format('hh:mm'), /*#__PURE__*/React.createElement("span", null, m.format('A'))), this.renderDurationAndGuests()));
    }
  }, {
    key: "renderTypeBadge",
    value: function renderTypeBadge() {
      return /*#__PURE__*/React.createElement("div", {
        className: "interview-type-badge body-text-4"
      }, capitalize(this.props.interviewType));
    }
  }, {
    key: "renderDurationAndGuests",
    value: function renderDurationAndGuests() {
      var _this$props$interview = this.props.interview,
        attendees = _this$props$interview.attendees,
        slot_duration_minutes = _this$props$interview.slot_duration_minutes;
      var numGuests = attendees.invitees.length;
      if (attendees.consultant) numGuests += 1;
      if (attendees.requester) numGuests += 1;
      return /*#__PURE__*/React.createElement("div", {
        className: "guests-count normal-weight"
      }, slot_duration_minutes, ' ', "mins\xA0\xB7\xA0", numGuests, ' ', "guests");
    }
  }, {
    key: "renderUpcoming",
    value: function renderUpcoming() {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "left-side"
      }, this.renderDateAndTime()), /*#__PURE__*/React.createElement("div", {
        className: "right-side"
      }, this.renderTypeBadge()));
    }
  }, {
    key: "renderPast",
    value: function renderPast() {
      return this.renderUpcoming();
    }
  }, {
    key: "renderReschedule",
    value: function renderReschedule() {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "left-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-4"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-bell"
      }), "Reschedule Requested")), this.renderDurationAndGuests()), /*#__PURE__*/React.createElement("div", {
        className: "right-side"
      }, this.renderTypeBadge()));
    }
  }, {
    key: "renderPending",
    value: function renderPending() {
      var _this$props2 = this.props,
        consultantView = _this$props2.consultantView,
        consultantInterviewPath = _this$props2.consultantInterviewPath,
        interview = _this$props2.interview;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "left-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-4"
      }, consultantView ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-bell"
      }), "\xA0Book Pending Interview\xA0", /*#__PURE__*/React.createElement("a", {
        href: "".concat(consultantInterviewPath, "?interview_id=").concat(interview.resource_id)
      }, "here")) : /*#__PURE__*/React.createElement("span", null, "Interview pending confirmation")), this.renderDurationAndGuests()), /*#__PURE__*/React.createElement("div", {
        className: "right-side"
      }, this.renderTypeBadge()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        interviewType = _this$props3.interviewType,
        consultantView = _this$props3.consultantView,
        repOrOwner = _this$props3.repOrOwner,
        availableInterviewSlotUrl = _this$props3.availableInterviewSlotUrl,
        interview = _this$props3.interview,
        possibleInterviewers = _this$props3.possibleInterviewers,
        invitableRoles = _this$props3.invitableRoles,
        csrfToken = _this$props3.csrfToken,
        onCancel = _this$props3.onCancel,
        onSubmitMeetingDetails = _this$props3.onSubmitMeetingDetails,
        canCancel = _this$props3.canCancel,
        canEdit = _this$props3.canEdit,
        isRep = _this$props3.isRep;
      var renderInterview = this.renderInterviewFuncMapping[interviewType];
      var _this$state = this.state,
        overlayPlacement = _this$state.overlayPlacement,
        showCard = _this$state.showCard;
      return /*#__PURE__*/React.createElement("div", {
        className: "interview-overlay-container",
        style: {
          position: 'relative'
        },
        ref: this.overlayContainerRef
      }, /*#__PURE__*/React.createElement("div", {
        className: "interview-container ".concat(interviewType, " ").concat(consultantView ? 'consultant-view' : ''),
        id: interview.id,
        ref: this.listItemRef,
        role: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "interview-body ".concat(interviewType)
      }, renderInterview())), /*#__PURE__*/React.createElement(Overlay, {
        show: showCard,
        onHide: this.handleOverlayClose,
        target: function target() {
          return _this2.listItemRef.current;
        },
        container: function container() {
          return _this2.overlayContainerRef.current;
        },
        placement: overlayPlacement,
        containerPadding: 20,
        rootClose: true
      }, /*#__PURE__*/React.createElement(Popover, {
        id: "popover-basic",
        className: "overlay-behind-modal"
      }, /*#__PURE__*/React.createElement(Popover.Body, null, /*#__PURE__*/React.createElement(InterviewCardOverlay, {
        interview: interview,
        interviewType: interviewType,
        possibleInterviewers: possibleInterviewers,
        invitableRoles: invitableRoles,
        csrfToken: csrfToken,
        onCancel: onCancel,
        onSubmitMeetingDetails: onSubmitMeetingDetails,
        canCancel: canCancel,
        canEdit: canEdit,
        consultantView: consultantView,
        closeOverlay: this.handleOverlayClose,
        isRep: isRep,
        editModalRef: this.setEditModalRef,
        resheduleModalRef: this.setResheduleModalRef,
        repOrOwner: repOrOwner,
        availableInterviewSlotUrl: availableInterviewSlotUrl
      })))));
    }
  }]);
}(Component);
Interview.propTypes = {
  interviewType: PropTypes.oneOf(['upcoming', 'pending', 'past', 'reschedule']).isRequired,
  interview: PropTypes.shape({
    accepted_time: interviewAvailabilityShape,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string
    }).isRequired,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    timezone: PropTypes.string.isRequired,
    slot_duration_minutes: PropTypes.number.isRequired,
    round_number: PropTypes.number,
    id: PropTypes.number.isRequired,
    edit_interview_path: PropTypes.string,
    cancel_interview_path: PropTypes.string,
    resource_id: PropTypes.string.isRequired
  }).isRequired,
  possibleInterviewers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  onCancel: PropTypes.func,
  onSubmitMeetingDetails: PropTypes.func,
  isRep: PropTypes.bool,
  canCancel: PropTypes.bool,
  canEdit: PropTypes.bool,
  consultantView: PropTypes.bool,
  repOrOwner: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  consultantInterviewPath: PropTypes.string,
  availableInterviewSlotUrl: PropTypes.string.isRequired
};
Interview.defaultProps = {
  possibleInterviewers: [],
  invitableRoles: [],
  onCancel: function onCancel() {
    return null;
  },
  onSubmitMeetingDetails: function onSubmitMeetingDetails() {
    return null;
  },
  isRep: false,
  consultantView: false,
  canEdit: false,
  canCancel: false,
  repOrOwner: false,
  consultantInterviewPath: ''
};
export default Interview;